export default class LeadMonitorService {
    constructor($http, appConfig) {
        "ngInject";

        this.$http = $http;
        this.appConfig = appConfig;
    }

    getEnquiriesBySource(criteria) {
        return this.$http.post(this.appConfig.apiServiceBaseUri + `api/leadmonitor/enquiriesBySource`, criteria);
    }

    getEnquiriesByOrigination(criteria) {
        return this.$http.post(this.appConfig.apiServiceBaseUri + `api/leadmonitor/enquiriesByOrigination`, criteria);
    }    
    
    getEnquiriesByBrand(criteria) {
        return this.$http.post(this.appConfig.apiServiceBaseUri + `api/leadmonitor/enquiriesByBrand`, criteria);
    }    

    getEnquiriesByModel(criteria) {
        return this.$http.post(this.appConfig.apiServiceBaseUri + `api/leadmonitor/enquiriesByModel`, criteria);
    }    

    getEnquiriesExpenditure(criteria) {
        return this.$http.post(this.appConfig.apiServiceBaseUri + `api/leadmonitor/enquiriesExpenditure`, criteria);
    }

    getWebEnquiriesBySource(criteria) {
        return this.$http.post(this.appConfig.apiServiceBaseUri + `api/leadmonitor/webenquiriesBySource`, criteria);
    }

    getWebEnquiriesByReason(criteria) {
        return this.$http.post(this.appConfig.apiServiceBaseUri + `api/leadmonitor/webenquiriesByReason`, criteria);
    }    

    getWebEnquiriesByBrands(criteria) {
        return this.$http.post(this.appConfig.apiServiceBaseUri + `api/leadmonitor/webenquiriesByBrands`, criteria);
    }    

    getWebEnquiriesByModel(criteria) {
        return this.$http.post(this.appConfig.apiServiceBaseUri + `api/leadmonitor/webenquiriesByModel`, criteria);
    }    

    getWebEnquiriesExpenditure(criteria) {
        return this.$http.post(this.appConfig.apiServiceBaseUri + `api/leadmonitor/webenquiriesExpenditure`, criteria);
    }
}
  


// WEBPACK FOOTER //
// ./client/app/components/leadMonitor/leadMonitor.service.js